import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './styles/title.css'
import './styles/subtitle.css'
import './styles/margin.css'


class Confirm extends Component {
  render() {
    return (
      <div className="registerBox">
        <h1 className="title">Email sent!</h1>
        <p className="subtitle margin margin--bottom-90">Check your <span className="h-breakable">{localStorage.getItem('last_submitted_email')}</span> inbox for instructions on how to reset your password. Please allow 5-10 minutes for the email to arrive.</p>
        <Link className="button" to='/logout'>Return to sign in</Link>
      </div>
    )
  }
}

export default Confirm



// WEBPACK FOOTER //
// ./src/confirm.js